import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import { useSpring, a } from '@react-spring/web';
import GooeyLink from './GooeyLink';
import { useTheme } from './ThemeContext';

// Import all images from the DIA folder
import dia1 from './images/HingeHealth/1.png';
import dia2 from './images/HingeHealth/2.png';
import dia3 from './images/HingeHealth/3.png';
import dia4 from './images/HingeHealth/4.png';
import dia5 from './images/HingeHealth/5.png';
import dia6 from './images/HingeHealth/6.png';

function HingeHealth() {
  // Create an array of all images
  const diaImages = [dia1, dia2, dia3, dia4, dia5, dia6];
  const { isDarkMode, toggleDarkMode } = useTheme();
  const [{ color }] = useSpring({ 
    color: isDarkMode ? '#FFFFFF' : '#000000' 
  }, [isDarkMode]);
  
  // Add this near the top of your component
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to scroll back to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <>
      {/* Full-width background */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: isDarkMode ? '#121212' : '#EFEFEF',
        zIndex: -1
      }} />
      
      <div className="tea-ceremony-page" style={{ 
        margin: '0 36px',
        position: 'relative',
        minHeight: '100vh'
      }}>
        {/* Navigation Bar - same as main page */}
        <a.div className="App-navigation" style={{ 
          color,
          position: 'relative',
          width: '100%',
          padding: '24px 0',
          marginTop: '0',
          transition: 'background 0.3s ease, color 0.3s ease'
        }}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <a.span className="name" style={{ color }}>Lou Kishfy</a.span>
          </Link>
          <div className="citySpan" style={{ 
            position: 'absolute', 
            left: '50%', 
            transform: 'translateX(-50%)',
            top: '26px',
            width: 'auto',
            textAlign: 'center'
          }}>
            <a.span style={{ color }}>New York, New York</a.span>
          </div>
          <div className="nav-links">
            <a.span className="link-spacing" style={{ 
              color,
              transform: 'translate(16px, -.5px)', 
              display: 'inline-block'
            }}>
              <GooeyLink 
                href="mailto:louis.kishfy@gmail.com?subject=Hey Lou, reaching out to..." 
                target="_blank"
                isDarkMode={isDarkMode}
                textColor={color}
              >
                Contact Me
              </GooeyLink>
            </a.span>
          </div>
        </a.div>
        
        {/* Grey divider that spans full width */}
        <div style={{ 
          width: '100%',
          height: '1px', 
          backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', 
          margin: '48px 0px 16px 0px',
          position: 'relative',
        }}></div>
        
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ fontSize: '48px', fontWeight: '600', color: isDarkMode ? '#FFFFFF' : '#000000' }}>Hinge Health</h1>
          <p style={{ fontSize: '18px', maxWidth: '800px', color: isDarkMode ? '#FFFFFF' : '#000000' }}>
          Developing and executing IPO readiness strategy for Hinge Health
          </p>
        </div>
        
        {/* Info and Team Section */}
        <div style={{ 
          display: 'flex', 
          flexDirection: isMobile ? 'column' : 'row', 
          marginBottom: '60px',
          gap: isMobile ? '30px' : '60px'
        }}>
          {/* Info Section */}
          <div style={{ flex: '1' }}>
            <h3 style={{ 
              fontSize: '16px', 
              fontWeight: '600',
              marginBottom: '12px',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
              Info
            </h3>
            <p style={{ 
              fontSize: '16px',
              lineHeight: '1.5',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
Hinge Health is a virtual physical therapy solution. It built its business primarily on a marketing deployment strategy, where we partner with employers and market to employee emails and home addresses twice a year.
<br /><br />
  
When I started at Hinge Health, we had no organic or paid acquisition strategy. During my tenure, I built a new organic acquisition strategy, seeded and developed new channels, and ran close to 100 experiments on the website to drive high-intent users into our product, driving over $30M in incremental revenue.
  <br /><br />

</p>
          </div>
          
          {/* Team Section */}
          <div style={{ flex: '1' }}>
            <h3 style={{ 
              fontSize: '16px', 
              fontWeight: '600',
              marginBottom: '12px',
              color: isDarkMode ? '#FFFFFF' : '#000000'
            }}>
              Team
            </h3>
            <p style={{ 
              fontSize: '16px',
              lineHeight: '1.5',
              color: isDarkMode ? '#FFFFFF' : '#555' // Dark grey for team text
            }}>
              Product Design: Lou Kishfy<br />
              Product Management: Adam Levinson<br />
              Software Development: Chris Ku, Chris Lee, Ravindra Shah, Kelsey Hodgson, Jonathan Ignacio, and Thomas Lombardi<br />
            </p>
          </div>
        </div>
    
        
        {/* Full-width images */}
        <div className="dia-images">
          {diaImages.map((image, index) => (
            <div key={index} className="dia-image-container" style={{ marginBottom: '20px' }}>
              <img 
                src={image} 
                alt={`Japanese Tea Ceremony - Image ${index + 1}`} 
                style={{ 
                  width: '100%', 
                  height: 'auto',
                  display: 'block'
                }} 
              />
            </div>
          ))}
        </div>
        
        {/* Full-width divider before footer */}
        
        {/* Full-width divider before footer */}
        <div style={{ 
          width: 'calc(100% + 72px)', // 100% plus the left and right margins (36px each)
          height: '1px', 
          backgroundColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', 
          margin: '60px -36px 0 -36px', // Negative margins to counter the page margins
          position: 'relative', // Ensure proper positioning
        }}></div>
        
        {/* Footer - exact match from App.js */}
        <a.div id="contact" className="footer" style={{ 
          marginTop: '40px',
          paddingTop: '0px',
          paddingBottom: '40px',
          paddingLeft: '0px',
          color
        }}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: '20px',
            marginBottom: '20px',
            marginLeft: '0px'
          }}>
            <h3 style={{ 
              fontSize: '24px', 
              fontWeight: '600', 
              marginBottom: '16px',
              marginLeft: '0px'
            }}>Find Me</h3>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '20px',
              marginBottom: '10px'
            }}>
              <GooeyLink 
                href="mailto:louis.kishfy@gmail.com" 
                isDarkMode={isDarkMode}
              >
                Email
              </GooeyLink>
              <GooeyLink 
                href="https://www.linkedin.com/in/louis-kishfy/" 
                target="_blank" 
                isDarkMode={isDarkMode}
              >
                LinkedIn
              </GooeyLink>
              <GooeyLink 
                href="https://github.com/LouisKishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
              >
                GitHub
              </GooeyLink>
              <GooeyLink 
                href="https://www.figma.com/@LouKishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
              >
                Figma
              </GooeyLink>
            </div>
            <div style={{ textAlign: 'left', display: 'inline-block', marginLeft: '0px' }}>
              <GooeyLink 
                href="https://x.com/louiskishfy" 
                target="_blank" 
                isDarkMode={isDarkMode}
                textColor={color}
              >
                X
              </GooeyLink>
            </div>
          </div>
          <div style={{ 
            marginTop: '30px', 
            textAlign: 'left',
            fontSize: '14px',
            opacity: 0.7,
            width: '100%'
          }}>
            <a.p style={{ color }}>© {new Date().getFullYear()} Lou Kishfy. All rights reserved.</a.p>
          </div>
        </a.div>
      </div>
    </>
  );
}

export default HingeHealth; 